<template>
    <div class="loginbg" style="display: none;">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form @submit.prevent="attemptResetPassword();" id="ResetPasswordCustomerForm">
                            <div class="form-group">
                                <label for="pass">Password</label>
                                <input placeholder="Password" name="password" ref="password" id='pass' v-model="password" v-validate="'required'" type="password" class="form-control">
                                <span class="color-c3202b float-l width-full font-text-regular-san" v-show="errors.has('password')">Password is required</span>
                            </div>
                            <div class="form-group">
                                <label for="confpass">Confirm Password</label>
                                <input id="confpass" placeholder="Confirm Password" name="confirmpassword" v-model="confirmpassword" v-validate="'required|confirmed:password'" type="password" class="form-control">
                                <span class="color-c3202b float-l width-full font-text-regular-san" v-if="errors.has('confirmpassword')" v-show="confirmpassword == ''">Confirm password is required</span>
                                <span class="color-c3202b float-l width-full font-text-regular-san" v-if="errors.firstByRule('confirmpassword','confirmed')" v-show="confirmpassword != ''">Password does not match</span>
                            </div>
                            
                            <span id="errorMsg" class="color-c3202b float-l width-full font-text-regular-san"></span>

                            <div>
                                <button id="sendEmail" class="btn general-button btn-primary" >Submit</button>
                                <router-link href="javascript:void(0)" v-bind:to="'/login'">Back</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    import SessioMixin from '../mixins/sessionmixin';
    Vue.use(VeeValidate);
    export default {
        name: 'ResetPassword',
        mixins: [SessioMixin],
        props: [''],
        components: {
        },
        data() {
            return {
                confirmpassword: '',
                password: '',
                userToekn: '',
            }
        },
        mounted: function () {
            $('.navbar').hide();
            $('.footer-main').hide();
            $('html,body,#app').css({height: "100%"});
            if(window.location.href.indexOf("/resetpassword") > -1) {
                $(".app-sidebar-right").css("padding-left","0px");
                $(".app-sidebar-right").css("margin-top","0px");
                $(".app-sidebar-right").css({"-webkit-transition":"all 0.0s ease","-moz-transition":"all 0.0s ease","-o-transition":"all 0.0s ease","transition":"all 0.0s ease"});
                $(".loginbg").show();
            }
            var self = this;
            self.userToekn = this.$route.params.token;
            //console.log(self.userToekn);
            setTimeout(function () {
                $('#pass').val('');
            }, 500);
        },
        methods: {
            attemptResetPassword() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        var app = this;
                        $('#errorMsg').html('');
                        $('#sendEmail').html('Submiting...');
                        $('#sendEmail').prop('disabled', true);
                        $.ajax({
                            url: process.env.ROOT_API + "/forgot/password",
                            type: "POST",
                            data: {token: app.userToekn, password: app.password},
                            dataType: 'json',
                            success: function (data) {
                                //console.log(data.code);
                                $('#sendEmail').html('Submit');
                                $('#sendEmail').prop('disabled', false);
                                if (data.status == "success") {
                                    $('.navbar').show();
                                    app.$router.push("/login");
                                }
                                if (data.code != 200) {
                                    $('#errorMsg').html(data.message);
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.Registerbtn = "Register";
                                if (jqXHR.status == 0) {
                                    self.registerError = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(jqXHR.responseJSON.message);
                                }
                            }
                        });
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ResetPassword.vue